// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { FileText, Image, FileSpreadsheet, File, FileVideo, FileAudio } from 'lucide-react';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatFileSize(bytes) {
  if (bytes === 0) return '0 B';
  
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

export function formatDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}

export function formatDateTime(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export function getFileIcon(contentType) {
  if (!contentType) return File;
  
  if (contentType.startsWith('image/')) {
    return Image;
  }
  
  if (contentType.includes('pdf')) {
    return FileText;
  }
  
  if (contentType.includes('spreadsheet') || contentType.includes('excel') || contentType.includes('csv')) {
    return FileSpreadsheet;
  }
  
  if (contentType.includes('video/')) {
    return FileVideo;
  }
  
  if (contentType.includes('audio/')) {
    return FileAudio;
  }
  
  if (contentType.includes('word') || contentType.includes('document')) {
    return FileText;
  }
  
  return File;
}

export function getFileExtension(filename) {
  return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
}

export function truncateFilename(filename, maxLength = 30) {
  if (filename.length <= maxLength) return filename;
  
  const ext = getFileExtension(filename);
  const nameWithoutExt = filename.slice(0, filename.lastIndexOf('.'));
  const truncatedName = nameWithoutExt.slice(0, maxLength - ext.length - 4) + '...';
  
  return `${truncatedName}.${ext}`;
}
